import { MailOpen, MapPin, Phone } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const [showScrollUp, setShowScrollUp] = React.useState(false);
  const lastScrollY = React.useRef(window.scrollY);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < lastScrollY.current) {
        setShowScrollUp(true); // Scrolling up
      } else {
        setShowScrollUp(false); // Scrolling down
      }
      lastScrollY.current = window.scrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className=" footercontainer">
      <div className="container">
        <div className="logorow">
          <img
            src="/assets/img/edraakwhitelogo.png"
            alt="Edraak Logo"
            className="edraaklogo"
          />
          <div className="socialmediarow">
            <a href="https://www.facebook.com/profile.php?id=61555049145245&mibextid=ZbWKwL" className="footsubitem"><img src="/assets/img/fblogo.png" alt="" className="socialicon" /></a>
            <a href="https://www.instagram.com/edraakonline/?igsh=MTRyOWpxeHV2b3ZvdA%3D%3D#" className="footsubitem"><img src="/assets/img/insta.png" alt="" className="socialicon" /></a>
            <a href="https://youtube.com/@edraakonline?si=pwbSNOI6AWiiCr_2" className="footsubitem"><img src="/assets/img/youtube.png" alt="" className="socialicon" /></a>
          </div>
        </div>
        <div className="footercontainer">
          <div>
            <div className="footercontentmain">
              {/* <div className="foothead">
                India’s premier Online Test Series Platform.
              </div> */}
              <div className="header-text">
                <span>India's premier </span>
                <span className="highlight">Online Test Series </span>
                <span>Platform.</span>
              </div>
            </div>

            <div className="location">
              <MapPin size={30} /><span>W W_VO/60,68/1523, 5th Floor, CM Mathew Brothers Arcade, Near Westway hotel, Chakkorathukulam, Calicat-673011</span>
            </div>
          </div>
          <div className="footersubcol">
            <Link to={'/'} className="footsubitem" >Home</Link>
            <Link to={'/aboutus'} className="footsubitem">About</Link>
            <Link to={'/contactus'} className="footsubitem">Contact Us</Link>
          </div>
          <div className="footersubcol">
            <Link to={'/cancellation-and-refund-policy'} className="footsubitem" >
              Cancel & Refund
            </Link>
            <Link to={'/terms-and-conditions'} className="footsubitem" >
              Terms & Conditions
            </Link>
            <Link to={'/privacy-policy'} className="footsubitem" >
              Privacy Policy
            </Link>
          </div>

          {showScrollUp && (
            <div className="top-scrl-btn">
              <img
                src="/assets/img/goup.png"
                alt=""
                className="goupicon"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              />
            </div>
          )}
        </div>
        <div
          className="footer-contact"
        >
          <div className="copyright">© Edraak 2025. All rights reserved.</div>
          <div className="phone-email ">
            <div className="phone">
              <Phone color="#FF843E" size={18} /> +91 88910 19993
            </div>
            <div className="phone">
              <MailOpen color="#FF843E" size={18} /> info@edraakonline.com
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
